import React, { useEffect, useRef, useState } from 'react'
import { useUserStore } from '../../store/userStore'
import { getReportDatasApi } from '../../api/survey'

import ReportFormRead from '../../components/survey/report/ReportFormRead'
import SavePDFButton from '../../components/common/pdf/SavePDFButton'
import { swalErrorAlert } from '../../utils/swal/swal'

const surveyDoneStyle = {
  padding: "2rem 1.5rem",
  border: "1px solid rgb(229, 229, 229)",
  borderRadius: "0.375rem"
}

const SurveyReportPage = () => {
  /* zustand */
  const { userInfo } = useUserStore((state) => state)
  const userId = userInfo?.user_id

  // 보고서 발급 여부
  const [report, setReport] = useState(false)

  // // 상담신청서 여부
  // // SLT/MCI 여부
  // const [surveyForm, setSurveyForm] = useState(false)
  // const [surveySlt, setSurveySlt] = useState(false)
  // const [surveyMci, setSurveyMci] = useState(false)


  // 보고서 정보
  const [reportInfo, setReportInfo] = useState(null)
  const [savedFiles, setSavedFiles] = useState([]) // 기존 파일

  useEffect(() => {
    getReportInfo(userId)

  }, [userId])

  const getReportInfo = async (userId) => {
    try {
      const response = await getReportDatasApi(userId)

      if (response.status === 200) {

        const jsonData = response.data?.resData?.json_data ? response.data?.resData?.json_data : null
        const savedFiles = response.data?.resData?.files ? response.data?.resData?.files : []

        setReport(true)
        setReportInfo(jsonData)
        setSavedFiles(savedFiles)
        return
      }
      else if (response.status === 204) {
        setReport(false)
        setReportInfo(null)
        setSavedFiles([])
        return
      }

    } catch (error) {
      setReport(false)
      swalErrorAlert()
      return
    }
  }

  const pdfRef = useRef();

  return (
    <div>
      <div className='mb-5'>
        <div className="d-flex align-items-center mb-3">
          <h2 className='h3 mb-0 me-3'>분석 결과 보고서</h2>
          {report && <SavePDFButton pdfRef={pdfRef} fileName={`${userInfo.name} 학생 분석 보고서`} btnColor={'secondary'} />}
        </div>
        <p className='fs-5'>상담 신청서와 SLT/MCI검사결과를 바탕으로 학생 맞춤 분석 결과 보고서를 확인합니다.</p>
      </div>

      {report ?
        <div style={{ overFlow: "auto" }}>
          <div style={{ minWidth: "1240px" }}>
            <ReportFormRead reportInfo={reportInfo} savedFiles={savedFiles} pdfRef={pdfRef} />
          </div>
        </div>
        :

        // (surveyForm && surveySlt && surveyMci) ?
        //   <div className='lh-lg text-center' style={surveyDoneStyle}>
        //     담당 컨설턴트가 결과 보고서를 작성중입니다.<br />
        //     결과 보고서 발급까지 최대 일주일 정도 소요됩니다.<br />
        //   </div>
        //   :
        <div className='lh-lg text-center' style={surveyDoneStyle}>
          결과 보고서 데이터가 없습니다.<br />
          상담 신청서와 SLT/MCI 검사를 먼저 진행해 주세요!<br />
        </div>
      }
    </div>
  )
}

export default SurveyReportPage